import { useEffect } from "react";
import globals from "web/script/modules/globals";

interface UseMutationObserverProps {
    ref: React.RefObject<HTMLDivElement>;
    callback: MutationCallback;
    observerOptions: MutationObserverInit;
}

const defaultObserverOptions: MutationObserverInit = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true,
};

export function useMutationObserver({
    callback,
    ref,
    observerOptions = defaultObserverOptions,
}: UseMutationObserverProps): void {
    useEffect(() => {
        // Create an observer instance linked to the callback function
        if (ref.current) {
            const observer = new globals.window.MutationObserver(callback);

            // Start observing the target node for configured mutations
            observer?.observe(ref.current, observerOptions);

            return (): void => {
                observer?.disconnect();
            };
        }
    }, [callback, ref, observerOptions]);
}
